import { createLucideIcon } from "lucide-react";

export const UserAccount = createLucideIcon(
    "UserAccount",
    [
        [
            "path",
            {
                d: "M10.5 8.99988C10.5 10.1044 9.60457 10.9999 8.5 10.9999C7.39543 10.9999 6.5 10.1044 6.5 8.99988C6.5 7.89531 7.39543 6.99988 8.5 6.99988C9.60457 6.99988 10.5 7.89531 10.5 8.99988Z",
                key: "1lfrd7",
            },
        ],
        [
            "path",
            {
                d: "M14 12.4999H17",
                key: "1w7od3",
            },
        ],
        [
            "path",
            {
                d: "M14 8.99988H18",
                key: "1t6x9n",
            },
        ],
        [
            "path",
            {
                d: "M5 15.9999C6.20831 13.4188 10.7122 13.249 12 15.9999",
                key: "zk7jg1",
            },
        ],
        [
            "rect",
            {
                height: "18",
                key: "16s30t",
                rx: "5",
                width: "20",
                x: "2",
                y: "2.99988",
            },
        ],
    ],
);
